import { Box, useTheme } from '@mui/material'
import TextInput from './BaseTextInput'
import StyledIcon from './StyledIcon'
import { useState } from 'react'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
  onBlur?: () => void
  onFocus?: () => void
}

export const SearchInput = ({ value, onChange, placeholder, autoFocus = false, onBlur, onFocus }: SearchInputProps) => {
  const theme = useTheme()
  const [isFocused, setIsFocused] = useState(false)

  const handleBlur = () => {
    onBlur?.()
    setIsFocused(false)
  }

  const handleFocus = () => {
    onFocus?.()
    setIsFocused(true)
  }

  return (
    <Box
      sx={{
        borderRadius: theme.shape.borderRadius,
        border: `2px solid ${isFocused ? theme.palette.primary.main : theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(0.5, 2),
        width: '100%',
      }}
    >
      <StyledIcon name='search' />
      <TextInput
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
    </Box>
  )
}
